define('bundles/signup/new',['require','jquery','sections/users/Podio.UI.Signup.SSO','react','react-dom','component!LoginProviderComponent','lib/Podio.SingleSignOn','lib/Podio.Routes','views/signup/Podio.Views.SignupForm','controllers/signup/Podio.Controllers.Signup.New'],function(require) {

  var $ = require('jquery');
  require('sections/users/Podio.UI.Signup.SSO');

  var React = require('react');
  var ReactDOM = require('react-dom');

  var LoginProviderComponent = require('component!LoginProviderComponent');

  var singleSignOn = require('lib/Podio.SingleSignOn');
  var routes = require('lib/Podio.Routes');

  var NewSignupFormView = require('views/signup/Podio.Views.SignupForm');
  var NewSignupController = require('controllers/signup/Podio.Controllers.Signup.New');

  new NewSignupController();
  new NewSignupFormView({
    el: $('form#new_user'),
    emailContainerSelector: 'dd'
  });

  var loginProviderComponentContainer = document.getElementById('loginProviderComponentContainer');

  function getElementByIdOrEmpty(e) {
    var ele = document.getElementById(e);
    return ele ? ele.value : '';
  }

  function onOAuthCompleted(data) {
    if (data.state === 'contact'
      || data.state === 'invite'
      || data.state === 'signin'
      || data.state === 'signup') {

      window.location.href = data.redirect_url;
      window.focus();
    }
  }

  var providers = {};

  Object.keys(singleSignOn.providerOptions).forEach(function(provider, i) {
    if (!!singleSignOn.providerOptions[provider].login) {
      providers[provider] = singleSignOn.providerOptions[provider];
    }
  });

  var props = {
    providers: providers,
    onProviderClick: onProviderClick,
    internal_source_type: getElementByIdOrEmpty('internal_source_type'),
    internal_source_id: getElementByIdOrEmpty('internal_source_id'),
    return_to: getElementByIdOrEmpty('return_to'),
    timezone: getElementByIdOrEmpty('timezone'),
    subtype: 'signup',
    translations: {
      'provider_sign_in': t('Sign Up with other Providers #signup')
    }
  };

  function onProviderClick(provider, event) {
    var url = routes.sso_start_path() + '?provider=' + provider;
    var ssoProps = [
      'return_to',
      'offering_id',
      'subtype',
      'timezone',
      'internal_source_type',
      'internal_source_id'
    ];

    ssoProps.forEach(function(prop) {
      if (props[prop]) {
        url += '&' + prop + '=' + props[prop];
      }
    });

    singleSignOn.popup(url, singleSignOn.providerOptions[provider].width, singleSignOn.providerOptions[provider].height);
  }

  if (loginProviderComponentContainer) {
    ReactDOM.render(React.createElement(LoginProviderComponent, props), loginProviderComponentContainer, function() {
      singleSignOn.signals.onOAuthComplete.add(onOAuthCompleted);
    });
  }
});

